module.exports = __webpack_public_path__ + "assets/images/thumbs-up-icon.4025bd1e36dbbaa9d443d09b37a3bf98.svg";